import { render, staticRenderFns } from "./ApproveCertificateReanalysisRequestButton.vue?vue&type=template&id=cb864c66&scoped=true&"
import script from "./ApproveCertificateReanalysisRequestButton.vue?vue&type=script&lang=js&"
export * from "./ApproveCertificateReanalysisRequestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb864c66",
  null
  
)

export default component.exports